import React from 'react'
import { Typography } from '@material-ui/core'

const GeneralTermsAndConditions = () => (
  <>
    <Typography variant='body2'>
      These General Terms and Conditions govern the use and the provision of the Glue Platform (“Glue”) by Glue Collaboration to the Customer. By accepting these General Terms and Conditions as part of an offer for or order of Glue, the Customer accepts these General Terms and Conditions and agrees to abide by them.
    </Typography>
    <br />
    <h1>
      1. Definitions
    </h1>
    <br />
    <p>
      As used in the Agreement, the following capitalized terms shall have the meaning set out below.
    </p>
    <br />
    <p>
      <strong>“Agreement”</strong> means the Order and any appendices attached thereto as well as any documents or terms referenced in the Order (including without limitation these General Terms and Conditions).
    </p>
    <br />
    <p>
      <strong>“Customer”</strong> means the entity specified in the Order that has ordered Glue.
    </p>
    <br />
    <p>
      <strong>“Customer Materials”</strong> mean all data and materials that the Customer generates in or submits to Glue Collaboration or Glue (including business information, presentations and documentation) that may concern the Customer or a third party, save for General Usage Data.
    </p>
    <br />
    <p>
      <strong>“Glue Collaboration”</strong> means Glue Collaboration (Business ID: 2273132-2), with its registered office at Meritullinkatu 11 C, 00170 Helsinki, Finland.
    </p>
    <br />
    <p>
      <strong>“Feedback”</strong> means the results of any evaluation of Glue by the Customer, including the Customer&apos;s opinions, observations, comments, criticisms, and suggested improvements, whether in written or oral form.
    </p>
    <br />
    <p>
      <strong>“General Usage Data”</strong> means general and anonymous usage, statistical and aggregate data pertaining to the Customer&apos;s or its users&apos; use of Glue (including anonymous analysis of Customer Materials).
    </p>
    <br />
    <p>
      <strong>“Glue”</strong> means the current and any further developments, updates and versions of the Glue Platform, tools and a configurable extended reality software platform for virtual collaboration including server hosting environment, back end and APIs, user device native applications and a web application and an authentication service developed or being developed by Glue Collaboration.
    </p>
    <br />
    <p>
      <strong>“Intellectual Property Rights”</strong> means copyrights and related rights (including database and catalogue rights and photography rights), patents, utility models, design rights, trademarks, tradenames, trade secrets, know-how and any other form of registered or unregistered intellectual property rights.
    </p>
    <br />
    <p>
      <strong>“License and Service Fees”</strong> mean the license and service fees payable for the provision of Glue to the Customer as further agreed in the Agreement.
    </p>
    <br />
    <p>
      <strong>“Order”</strong> means a written (including electronic form) order or offer regarding Customer&apos;s purchase of a right to use Glue as executed between the Customer and Glue Collaboration (or Glue Collaboration Partner on behalf of Glue Collaboration), including orders made per email and including offers for Glue by Glue Collaboration (or Glue Collaboration Partner on behalf of Glue Collaboration), accepted by the Customer by signature or otherwise (e.g. per email or by placing an order with Glue Collaboration Partner).
    </p>
    <br />
    <p>
      <strong>“Party”</strong> means the Customer or Glue Collaboration (jointly the “Parties”).
    </p>
    <br />
    <p>
      <strong>“Subscription Period”</strong> means the prepaid term during which the Customer is entitled to use and has access to Glue as further agreed in the Agreement.
    </p>
    <br />
    <h1>
      2. Use of Glue
    </h1>
    <br />
    <h2>
      Provision of Glue
    </h2>
    <br />
    <p>
      Subject to the terms and conditions of the Agreement and the due payment of any applicable fees, Glue Collaboration hereby grants to the Customer and the Customer hereby accepts a limited, non-exclusive, nontransferable, and non-sublicensable right for the Customer to use Glue in the Customer&apos;s and its group companies&apos; business for pilot and demonstration purposes during the Subscription Period as set out in the Order. Any further use purposes may be separately agreed in the Order.
    </p>
    <br />
    <p>
      The Customer agrees to comply with the volume licenses and amount of user rights agreed in the Agreement. Glue Collaboration may monitor the Customer&apos;s compliance in Glue. In the event that the Customer has underpaid License or Service Fees or that the Customer has used Glue in excess of the licenses or user rights amounts purchased by the Customer (on the Order or otherwise), the Customer shall compensate such underpayment and/or excess usage based on the then-current Glue Collaboration&apos;s price list.
    </p>
    <br />
    <h2>
      Usage restrictions
    </h2>
    <br />
    <p>
      The Customer is not permitted and not entitled to permit others to do any of the following:
    </p>
    <br />
    <li>Copy, modify, distribute, rent, sub-license, sell, lease Glue or otherwise make them available to or grant access to third parties without the prior written consent of Glue Collaboration;</li>
    <li>Circumvent or try to circumvent any usage control or anti-copy functionalities of Glue;</li>
    <li>Reverse engineer or decompile Glue or access the source code thereof, except as permitted by law, provided, however, that this limitation shall only apply to those parts of Glue and the source code thereof that are proprietary to Glue Collaboration and does not limit the application of permissive terms and conditions pertaining to any third party components used in Glue;</li>
    <li>Use Glue in violation of applicable law;</li>
    <li>To use Glue in ways that violate Intellectual Property Rights, business secrets, or privacy rights of third parties;</li>
    <li>Use Glue for the purposes of reselling Glue to third parties;</li>
    <li>Remove any product identification, copyright, trademark or other notice from Glue.</li>
    <br />
    <p>
      Glue Collaboration shall have the right to deny the Customer&apos;s use of Glue without any prior notice to the Customer, if Glue Collaboration suspects that the Customer uses Glue in violation of the terms of the Agreement.
    </p>
    <br />
    <h2>
      General obligations of Customer
    </h2>
    <br />
    <p>
      The Customer is responsible for acquiring any and all network connections and all technical equipment required for using Glue and is liable for any costs thereof.
    </p>
    <br />
    <p>
      The Customer agrees that it shall indemnify and hold Glue Collaboration harmless from and against any and all liabilities, losses, damages, costs, and expenses (including reasonable legal fees and expenses) associated with any claim or action brought against Glue Collaboration that may arise from the Customer&apos;s use of Glue in breach of the Agreement, including claims that the Customer Materials infringe the Intellectual Property Rights of third parties or violates the privacy rights of any individual under applicable laws.
    </p>
    <br />
    <h1>
      3. Acceptance and Security
    </h1>
    <br />
    <h2>
      Accepting the Agreement
    </h2>
    <br />
    <p>
      The person accepting the Agreement represents that it has the authority to bind the Customer to the Agreement.
    </p>
    <br />
    <p>
      The Customer shall ensure that all details provided regarding the Customer&apos;s contact information and billing information where applicable, are correct and undertakes to update such information as soon as possible in case such information has changed.
    </p>
    <br />
    <h2>
      Security and unauthorized use
    </h2>
    <br />
    <p>
      The Customer shall use all reasonable endeavours to prevent unauthorised access to, or use of, Glue. The Customer shall ensure that a possible username, passwords, and equivalent information obtained by the Customer in conjunction with registration to Glue are kept confidential and stored and used in a secure manner and cannot be accessed or used by third parties.
    </p>
    <br />
    <p>
      Where it is suspected that any unauthorised person has become aware of a username and/or password, the Customer shall immediately inform Glue Collaboration thereof and change such username and/or password.
    </p>
    <br />
    <p>
      The Customer shall be liable for any use of Glue with the usernames and/or passwords of the Customer.
    </p>
    <br />
    <h1>
      4.Data
    </h1>
    <br />
    <h2>
      Rights to Customer Materials
    </h2>
    <br />
    <p>
      The Intellectual Property Rights and the title to Customer Materials shall belong to the Customer.
    </p>
    <br />
    <p>
      Glue Collaboration may use, copy, store, and modify Customer Materials during the term of the Agreement for the purpose of providing Glue to the Customer in accordance with the Agreement. Glue Collaboration agrees to treat Customer Materials as confidential information in accordance with Section 7 below.
    </p>
    <br />
    <p>
      Glue shall not be used as a storage service. The Customer shall be solely responsible for taking and storing appropriate backup copies of Customer Materials.
    </p>
    <br />
    <p>
      Upon termination of the Agreement, the Customer shall primarily use the features of Glue in transferring Customer Materials to the Customer. After termination of the Agreement, Glue Collaboration will cease processing the Customer Materials in Glue.
    </p>
    <br />
    <h2>
      Liability for Customer Materials
    </h2>
    <br />
    <p>
      The Customer shall be responsible for the Customer Materials and shall be liable for ensuring that Customer Materials does not infringe any third-party rights or violate applicable legislation, and that the Customer possesses such necessary licences and permissions from third parties as may be required in order to use the Customer Materials as set out herein.
    </p>
    <br />
    <h2>
      Personal Data
    </h2>
    <br />
    <p>
      In case the Customer Materials contain personal data to be processed by Glue Collaboration on Customer&apos;s behalf as a data processor, such processing of personal data shall be governed by a separate data processing agreement between the Customer and Glue Collaboration attached to or referenced in the Order.
    </p>
    <br />
    <h2>
      General Usage Data
    </h2>
    <br />
    <p>
      Glue Collaboration shall have the right to generate and obtain General Usage Data from the Customer&apos;s and its users&apos; use of Glue for the purposes of e.g. developing and improving Glue. The Intellectual Property Rights and title to General Usage Data shall belong to Glue Collaboration. For clarity, General Usage Data shall not in any event be used in a manner that identifies the Customer or any natural person or any Customer Materials.
    </p>
    <br />
    <h1>
      5. Provision of Glue
    </h1>
    <br />
    <h2>
      Availability
    </h2>
    <br />
    <p>
      The Customer understands that Glue may be inaccessible, unavailable or inoperable for any reason including maintenance. Glue Collaboration shall at all times have the right to temporarily suspend the provision of Glue.
    </p>
    <br />
    <p>
      The Customer acknowledges that interruptions to the availability of Glue may also occur, for example, in the event of data connection or network disruptions or in case of interruptions in third-party services. Glue Collaboration shall in no event be liable for such interruptions.
    </p>
    <br />
    <h2>
      Changes in Glue
    </h2>
    <br />
    <p>
      Glue Collaboration may at its sole discretion at any time modify and update Glue or a part thereof. Subject to the termination periods agreed herein, Glue Collaboration may also, at its sole discretion at any time cease to provide Glue. Glue Collaboration reserves the right to implement new versions of Glue.
    </p>
    <br />
    <h1>
      6. Fees and Payment
    </h1>
    <br />
    <h2>
      License and Service Fees
    </h2>
    <br />
    <p>
      In return for Customer&apos;s use of Glue, the Customer shall pay the License and Service Fees to Glue Collaboration set out in the Order.
    </p>
    <br />
    <p>
      All prices are exclusive of VAT and any other applicable taxes or fees/payment charges imposed by public authorities or financial institutions from time to time. Such taxes and fees shall be added to the prices and be borne by the Customer.
    </p>
    <br />
    <p>
      All payments made in accordance with the Agreement are non-refundable. For clarity, in the event of early termination, the Customer shall not be entitled to a refund of any prepaid fees.
    </p>
    <br />
    <h2>
      Payment terms
    </h2>
    <br />
    <p>
      The payment term is 14 days net from the date of invoice.
    </p>
    <br />
    <p>
      Notices relating to invoices or payments hereunder shall be given in writing within 7 days from the date of receipt of the relevant invoice.
    </p>
    <br />
    <p>
      Interest on overdue payments shall be payable according to the Finnish Interest Act. The Customer shall be responsible for the reasonable costs incurred by Glue Collaboration when collecting overdue fees.
    </p>
    <br />
    <p>
      Without prejudice to its other rights, Glue Collaboration may temporarily disable the Customer&apos;s access to or cease providing Glue in the event the Customer has overdue payments in excess of 14 days.
    </p>
    <br />
    <h2>
      Price adjustments
    </h2>
    <br />
    <p>
      Glue Collaboration shall be entitled to adjust the fees and charges of Glue (excluding, however, the price of any perpetual licenses obtained by Customer) at any time by 14 days prior notice.
    </p>
    <br />
    <h1>
      7. Confidentiality
    </h1>
    <br />
    <p>
      Neither Party shall disclose to third parties any material or information received from the other Party or through the use of Glue and marked as confidential or which should be understood to be confidential, and shall not use such material or information for any other purposes than those stated in the Agreement.
    </p>
    <br />
    <p>
      Customer Materials are confidential information and the confidentiality obligations stated herein shall apply.
    </p>
    <br />
    <p>
      The confidentiality obligations shall, however, not be applied to material or information, (a) which is generally available or otherwise public; or (b) which the Party has received from a third party without any obligation of confidentiality as verified by the written records of such Party; or (c) which a Party has independently developed without using material or information received from the other Party as verified by the written records of such Party; (d) which a Party is obligated to disclose due to applicable mandatory laws, public authority regulations or court orders. In case of disclosure due to (d), the Party much promptly inform the other Party of such disclosure.
    </p>
    <br />
    <p>
      The rights and responsibilities under this Section 7 shall survive the expiry or termination of the Agreement for a period of 5 years after the expiry or termination of the Agreement.
    </p>
    <br />
    <h1>
      8. Intellectual Property Rights
    </h1>
    <br />
    <h2>
      Ownership of Intellectual Property Rights to Glue
    </h2>
    <br />
    <p>
      All Intellectual Property Rights in or related to Glue and thereto related documentation and all parts and copies thereof shall remain exclusively vested with and be the sole and exclusive property of Glue Collaboration.
    </p>
    <br />
    <p>
      Except as expressly stated herein, the Agreement does not grant the Customer any Intellectual Property Rights in Glue and all rights not expressly granted hereunder are reserved by Glue Collaboration and its subcontractors/licensors.
    </p>
    <br />
    <h2>
      Feedback
    </h2>
    <br />
    <p>
      In the event that the Customer, acting in its sole discretion, supplies to Glue Collaboration any Feedback (including all suggestions, comments, feedback, ideas, source code, and/or know-how), the Customer hereby grants to Glue Collaboration a perpetual, irrevocable, royalty free, non-exclusive, worldwide license to use, copy and modify the Feedback for the purposes of: (i) supporting the Customer in connection with the Agreement; and (ii) developing and improving Glue, which may incorporate the Feedback including, but not limited to, correction of errors and debugging Glue.
    </p>
    <br />
    <h2>
      Infringement of third party IPR
    </h2>
    <br />
    <p>
      Glue Collaboration will defend the Customer against any claim that Glue infringes the Intellectual Property Rights of a third party and pay any damages finally settled or awarded in a trial to the third party with respect to any such claim, provided that Glue Collaboration is notified promptly in writing of the claim and given sole control of the defence and all related settlement negotiations in relation to the claim as well as reasonable assistance and necessary authorizations from the Customer to defend or settle the claims on behalf of the Customer.
    </p>
    <br />
    <p>
      At any time, if Glue Collaboration reasonably deems that any part of Glue infringes the intellectual property rights of any third party,Glue Collaboration has the right at its own expense to: (i) modify/replace Glue to eliminate the infringement in such a manner that the modified Glue complies with the Agreement; or (ii) procure to the Customer a right to use Glue. If none of the aforementioned alternatives are reasonably possible, Glue Collaboration shall have the right to terminate the Agreement and Glue Collaboration shall refund to the Customer the prices paid for Glue by the Customer less the price corresponding the time the Customer has been able to use Glue in accordance with the Agreement.
    </p>
    <br />
    <p>
      Glue Collaboration shall, however, not be liable for any infringement or claim thereof in the event the claim: (i) is made by any affiliate of the Customer; (ii) has resulted from the Customer&apos;s or its user&apos;s use or modification of or addition to Glue (including the Customer&apos;s disposition of Customer Materials in Glue); or (iii) could have been avoided by using the latest version of Glue provided by Glue Collaboration.
    </p>
    <br />
    <h1>
      9. No Warranty
    </h1>
    <br />
    <p>
      To the extent permitted by applicable law, Glue is provided “as is” without warranty of any kind, either express or implied, including but not limited to the implied warranties of merchantability, and noninfringement, and fitness for a particular purpose, or accuracy or reliability of results from use of Glue , that Glue will meet specific requirements, that Glue will be uninterrupted, completely secure, free of software errors, defects and failures.
    </p>
    <br />
    <h1>
      10. Limitation of Liability
    </h1>
    <br />
    <p>
      Neither Party shall be liable to the other Party for any indirect or consequential damages, including loss of profits, loss of business, loss of data or interruption business.
    </p>
    <br />
    <p>
      Glue Collaboration&apos;s total aggregate liability under or in connection with the Agreement shall be limited to 50% of the fees the Customer has paid for Glue during the 6-month period preceding the claim for damages.
    </p>
    <br />
    <p>
      These limitations of liability shall not apply in cases of intentional misconduct or gross negligence.
    </p>
    <br />
    <h1>
      11. Term and Termination
    </h1>
    <br />
    <p>
      The Agreement shall enter into force as of the acceptance of the Agreement. The Agreement shall stay in force until the Agreement is terminated as set out below.
    </p>
    <br />
    <p>
      Unless the Parties have agreed on a separate term and termination provisions in the Order, the Agreement may be terminated without cause at any moment with a 60 days&apos; prior notice to the other Party.
    </p>
    <br />
    <p>
      Without prejudice to any other rights or remedies to which the Parties may be entitled, either Party may terminate the Agreement without liability to the other if: (i) the other Party commits a material breach of the Agreement and (if such breach is remediable) fails to remedy that breach within 30 days of that Party being notified in writing of the breach; or (ii) the other Party is dissolved or liquidated, is declared bankrupt or otherwise becomes the subject to other insolvency proceedings.
    </p>
    <br />
    <p>
      The provisions of the Agreement which by their nature reasonably should survive the termination or expiration of the Agreement shall survive any expiration or termination of the Agreement.
    </p>
    <br />
    <h1>
      12. Miscellaneous
    </h1>
    <br />
    <h2>
      Notices
    </h2>
    <br />
    <p>
      Any notice or other written communication to be given by the Customer to Glue Collaboration under the Agreement shall be in English and sent by email to the email address stated in the Order.
    </p>
    <br />
    <p>
      Any notice or other written communication to be given by Glue Collaboration to the Customer under the Agreement shall be in English and sent by email to the email address indicated in the Order.
    </p>
    <br />
    <p>
      If either Party is to change their respective contact details, the other Party shall be informed thereof in advance.
    </p>
    <br />
    <h2>
      Subcontractors
    </h2>
    <br />
    <p>
      Glue Collaboration shall be entitled to use subcontractors, including third party software suppliers, for the provision of Glue. Glue Collaboration shall be liable for the subcontractors&apos; work and services in the same manner as for its own work and services.
    </p>
    <br />
    <h2>
      Export Restrictions
    </h2>
    <br />
    <p>
      The Customer agrees to comply with any export restrictions in force in any jurisdiction that may be applied to the provision of Glue hereunder.
    </p>
    <br />
    <h2>
      Entire Agreement
    </h2>
    <br />
    <p>
      The Agreement supersedes all prior agreements, arrangements, and understandings between the Parties relating to the subject matter hereof, and constitutes the entire agreement between the Parties relating to the subject matter hereof.
    </p>
    <br />
    <h2>
      Severance
    </h2>
    <br />
    <p>
      If any provision of the Agreement is declared by any judicial or other competent authority to be void, illegal or otherwise unenforceable, the remaining provisions of the Agreement shall remain in full force and effect.
    </p>
    <br />
    <h2>
      Headings
    </h2>
    <br />
    <p>
      Headings used in the Agreement are for convenience only and do not alter the meaning or interpretation of any provision herein.
    </p>
    <br />
    <h2>
      Amendments
    </h2>
    <br />
    <p>
      Glue Collaboration is entitled to amend the Agreement by providing the Customer with at least 60 days&apos; prior notice. If the Customer does not accept the change made by Glue Collaboration to the Agreement, the Customer has the right to terminate the Agreement by notifying Glue Collaboration thereof in writing prior to the effective date of such change.
    </p>
    <br />
    <h2>
      Assignment
    </h2>
    <br />
    <p>
      Glue Collaboration shall be entitled to assign all or any of its rights or obligations hereunder in whole or part to an affiliate or business partner or successor or to a purchaser or acquirer of its business assets relating to Glue without the Customer&apos;s prior consent.
    </p>
    <br />
    <p>
      The Customer shall not be entitled to assign any of its rights or obligations hereunder in whole or part without the prior written consent of Glue Collaboration.
    </p>
    <br />
    <h2>
      Force Majeure
    </h2>
    <br />
    <p>
      Both Parties shall be excused and shall not be responsible for any failure to comply with the terms of the Agreement due to causes beyond their control or the control of their suppliers, including but not limited to war, insurrection, riot or other civil disobedience, quarantine restriction, labour dispute except within either Party&apos;s organisation, failure or delay in transportation, accidents, flood, earthquake, fire, storm or other act of God, act of any government or any agency thereof, judicial action or act.
    </p>
    <br />
    <p>
      Where a Party&apos;s performance is prevented for a period in excess of one month due to an event as stated above, either Party shall be entitled to terminate the Agreement in writing without any obligation to pay compensation.
    </p>
    <br />
    <h2>
      Applicable law and dispute resolution
    </h2>
    <br />
    <p>
      The Agreement shall be governed by and construed in accordance with the laws of Finland, except for its provisions on choice of law.
    </p>
    <br />
    <p>
      Any dispute, controversy or claim arising out of or relating to the Agreement, or the breach, termination or validity thereof, shall be finally settled by arbitration in accordance with the Arbitration Rules of the Finland Chamber of Commerce. The number of arbitrators shall be one. The seat of arbitration shall be Helsinki, Finland.
    </p>
    <br />
    <p>
      With respect to any violation by the Customer of any Intellectual Property Rights and/or confidential information of Glue Collaboration and/or payment obligations against Glue Collaboration under the Agreement, Glue Collaboration shall have the right, at its sole discretion, to seek remedies in public courts within any relevant territory
    </p>
  </>
)

export default GeneralTermsAndConditions
